/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, BoxView, Text, Avatar, ActionButton, Button } from '@components/atoms'
import { Grid } from '@grid'
import { adminUsersColumns } from '@grid'

import { useNavigate } from 'react-router-dom'
import {
	useAppSelector,
	useAppDispatch,
	adminUsersActions,
	ApiGetDataStatus,
} from '@redux/index'
import { UserType } from '@schemas'
import { GridRowModel, GridRenderCellParams } from '@mui/x-data-grid'
import { blue } from '@mui/material/colors'

const AdminUsersPage = () => {
	const reduxDispatch = useAppDispatch()

	const navigate = useNavigate()

	// redux state
	const userList: UserType[] = useAppSelector(state => state.adminUsers.userList)
	const status: ApiGetDataStatus = useAppSelector(
		state => state.adminUsers.userListStatus,
	)

	const onAction = (iudFlag: string, aRow: GridRowModel) => {
		const newData = {
			iudFlag: iudFlag,
			id: aRow.id,
			name: aRow.name,
			email: aRow.email,
			language: aRow.language,
			useYn: aRow.useYn,
		}
		reduxDispatch(adminUsersActions.UPDATE_USER({ ...newData }))
	}

	return (
		<View css={style}>
			<BoxView title="사용자 관리">
				<Grid
					rows={userList}
					columns={adminUsersColumns}
					loading={status === 'loading'}
					onAction={onAction}
					renderCell={{
						avata: (
							params: GridRenderCellParams<
								{ id: string; name: string; color: string; imageUrl: string },
								any,
								any
							>,
						) => {
							if (params.value === null) {
								return <></>
							}

							return (
								<Avatar
									picture={params.value.imageUrl}
									name={params.value.name}
									color={params.value.color}
								/>
							)
						},
						password: () => {
							return <Text>********</Text>
						},
					}}
					renderEditCell={{
						avata: (params: GridRenderCellParams) => {
							const onEditClick = () => {
								reduxDispatch(
									adminUsersActions.EDIT_USER_PROFILE_IMAGE({ id: params.value.id }),
								)
							}

							return (
								<View style={{ display: 'flex', alignItems: 'center' }}>
									<Avatar
										picture={params.value.imageUrl}
										name={params.value.name}
										color={params.value.color}
									/>

									<ActionButton
										iconName="cog"
										style={{
											backgroundColor: blue['A400'],
											borderRadius: '50%',
											height: '2rem',
											width: '2rem',
										}}
										iconTextColor={'white'}
										onClick={onEditClick}
									/>
								</View>
							)
						},
						password: (params: GridRenderCellParams) => {
							const onClick = () => {
								navigate('/admin/reset-password')
								reduxDispatch(adminUsersActions.EDIT_UPASSWORD_USER({ ...params.value }))
							}

							if (params.row.isNew) {
								return <></>
							}

							return (
								<Button variant="contained" onClick={onClick}>
									수정
								</Button>
							)
						},
					}}
				/>
			</BoxView>
		</View>
	)
}

export default AdminUsersPage

const style = css({})
